import Icon from '../components/Icon.vue'

Icon.register({
  wheelchair: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496.1 385.7l14.2 28.7c3.9 7.9 0.7 17.5-7.2 21.4l-65.5 32.9c-16 8-35.6 1.2-43.2-15.1l-62.8-133.6h-139.7c-15.9 0-29.4-11.7-31.7-27.5-33.9-237.2-31.9-222.5-32.3-228.5 0-36.4 30.3-65.6 67.1-63.9 33.3 1.5 60 28.9 60.9 62.2 0.9 32.9-23.2 60.4-54.6 65l4.7 32.7h130c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-120.8l4.6 32h132.2c11.2 0 24.2 8.2 29 18.4l57.5 122.4 36.2-18.3c7.9-3.9 17.5-0.7 21.4 7.2zM311.4 352l25.8 54.8c-27.3 61.9-89.2 105.2-161.1 105.2-97 0-176-79-176-176 0-74 46-137.5 110.8-163.5 2.6 18.5 5.8 40.4 9.5 66.3-33.6 19.3-56.3 55.7-56.3 97.2 0 61.8 50.2 112 112 112 56.3 0 103.1-41.8 110.9-96h24.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wheelchair.js
// module id = 2108
// module chunks = 0